module.exports = __webpack_public_path__ + "static/img/encounter.7ad5e6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/encounter.jpg
// module id = ushy
// module chunks = 7